import React from 'react'
import { playSound, stopSound, setVolume, replaceSound, getSound } from "../../Sounds"

const stoppedState = {
  playButtonValue: "\u25B6", //play icon (a triangle)
  isPlaying: false
}

const playingState = {
  playButtonValue: "\u25A0", //stop icon (a square)
  isPlaying: true
}

/**
 * A component for a single sound, used in the
 * Sound sub-category in DevTools.
 */
export default class SoundSelector extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      playButtonValue: "\u25B6",
      isPlaying: false,
      soundName: this.props.soundName,
      soundVolume: this.props.volume || 1
    }
  }

  /**
   * Update the state of this component, when
   * a new volume value is received.
   * @param {object} nextProps
   */
  componentWillReceiveProps(nextProps) {
    if (this.props.volume !== nextProps.volume) {
      this.setState({ soundVolume: nextProps.volume })
    }
  }

  /**
   * Plays out the sound.
   */
  playSample = () => {
    const soundID = playSound(this.state.soundName)

    getSound(this.state.soundName)
      .on('end', () => {
        this.setState(Object.assign({}, stoppedState))
      }, soundID)
    this.setState(Object.assign({}, playingState))
  }

  /**
   * Stops the sound from playing.
   */
  stopSample = () => {
    stopSound(this.state.soundName)
    this.setState(Object.assign({}, stoppedState))
  }

  /**
   * The toggle button which switches between play and stop.
   */
  toggleSample = () => {
    if (!this.state.isPlaying) {
      this.playSample()
    } else {
      this.stopSample()
    }
  }

  /**
   * Sets the volume of the sound.
   * @param event
   */
  setSampleVolume = (event) => {
    const percentage = (event.target.value / 100) || 0.001
    setVolume(this.state.soundName, percentage)

    this.setState({
      soundVolume: percentage
    })
  }

  /**
   * Upload a new sound and replace the current one.
   * @param {object} event -
   */
  replaceSample = (event) => {
    this.stopSample()

    const files = event.target.files
    const reader = new FileReader()

    reader.onload = () => {
      replaceSound(this.state.soundName, reader.result, this.state.soundVolume)
    }

    reader.readAsDataURL(files[0])
  }

  render() {
    const name = this.state.soundName
    const volume = (this.state.soundVolume * 100)

    return (
      <div className="devSelector">
        <span className="label">{name}</span>
        <div className="soundControls">
          <input type="button" value={this.state.playButtonValue} onClick={this.toggleSample} />
          <div className="volumeControl">
            <input type="range" onChange={this.setSampleVolume} value={volume || 0} />
            {volume.toFixed(0)}%
          </div>
        </div>
        <input className="replacementControls" type="file" id={this.state.soundName} accept="audio/*"
          onChange={this.replaceSample} />
      </div>
    )
  }
}
